module.exports = __webpack_public_path__ + "static/media/avatar.d09db942.png";